<template>
  <div class="flex">
    <TheNavbar class="fixed left-0 right-0 z-10" />
    <main class="mt-[60px] max-w-full flex-1 p-4 md:p-8">
      <slot />
    </main>
  </div>
</template>
